import { acceptedMimeTypes } from './AcceptedMimeTypes';
export var fileUploaderOptions = {
    concurrency: 1,
    allowedContentTypes: acceptedMimeTypes
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmlsZVVwbG9hZGVyU2V0dGluZ3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJGaWxlVXBsb2FkZXJTZXR0aW5ncy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxxQkFBcUIsQ0FBQztBQUV4RCxNQUFNLENBQUMsSUFBTSxtQkFBbUIsR0FBb0I7SUFDaEQsV0FBVyxFQUFFLENBQUM7SUFDZCxtQkFBbUIsRUFBRSxpQkFBaUI7Q0FDekMsQ0FBQyJ9